/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ordercheck': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M896.174 63.868l-832.162.078v831.693h384.075V831.72l-320.062.044-.035-703.774h704.171v320.218h64.012V63.868z"/><path pid="1" d="M192.08 319.871h384.075v-63.919H192.08v63.919zm0 127.768l320.062.069V383.79H192.08v63.849zm0 128.317h192.037v-63.891l-192.037-.028v63.919zm723.342 25.331L645.75 870.958 510.717 735.925l-44.946 44.945 180.045 180.045 44.945-44.945 269.672-269.672z"/>'
  }
})
